package com.macrofocus.eflux.deckgl

import org.locationtech.jts.geom.*

fun multiPolygonToDeckGL(multiPolygon: MultiPolygon): List<Array<Array<DoubleArray>>> {
    val deckPolygons = mutableListOf<Array<Array<DoubleArray>>>()

    for (i in 0 until multiPolygon.numGeometries) {
        val deckPolygon = mutableListOf<Array<DoubleArray>>()

        val polygon = multiPolygon.getGeometryN(i) as Polygon

        // Convert outer boundary (shell)
        val outerRing = polygon.exteriorRing?.coordinates?.map { coord ->
            doubleArrayOf(coord.x, coord.y)
        }

        val flat = outerRing!!.toTypedArray()
        deckPolygon.add(flat)

        for (j in 0 until polygon.getNumInteriorRing()) {
            val interiorRing = polygon.getInteriorRingN(j).coordinates.map { coord ->
                doubleArrayOf(coord.x, coord.y)
            }
            val flat = interiorRing.toTypedArray()
            deckPolygon.add(flat)
        }

            // Convert holes (if any)
//        val holes = polygon.inte?.map { hole ->
//            hole.coordinates!!.map { coord ->
//                listOf(coord.x, coord.y)
//            }
//        }

        // Combine outer ring and holes into one polygon
//        val fullPolygon: MutableList<List<List<Double>>?> = mutableListOf(outerRing)
//        fullPolygon.addAll(holes)

        deckPolygons.add(deckPolygon.toTypedArray())
    }

    return deckPolygons
}

fun polygonToDeckGL(polygon: Polygon): Array<Array<DoubleArray>> {
    val deckPolygon = mutableListOf<Array<DoubleArray>>()

    // Convert outer boundary (shell)
    val outerRing = polygon.exteriorRing?.coordinates?.map { coord ->
        doubleArrayOf(coord.x, coord.y)
    }

    val flat = outerRing!!.toTypedArray()
    deckPolygon.add(flat)

    for (j in 0 until polygon.getNumInteriorRing()) {
        val interiorRing = polygon.getInteriorRingN(j).coordinates.map { coord ->
            doubleArrayOf(coord.x, coord.y)
        }
        val flat = interiorRing.toTypedArray()
        deckPolygon.add(flat)
    }

        // Convert holes (if any)
//        val holes = polygon.inte?.map { hole ->
//            hole.coordinates!!.map { coord ->
//                listOf(coord.x, coord.y)
//            }
//        }

    // Combine outer ring and holes into one polygon
//        val fullPolygon: MutableList<List<List<Double>>?> = mutableListOf(outerRing)
//        fullPolygon.addAll(holes)


    return deckPolygon.toTypedArray()
}


fun removeDuplicatePoints(coord: Array<Coordinate>): Array<Coordinate> {
    val uniqueCoords: MutableList<Coordinate> = ArrayList()
    var lastPt: Coordinate? = null
    for (i in coord.indices) {
        if (lastPt == null || lastPt != coord[i]) {
            lastPt = coord[i]
            uniqueCoords.add(Coordinate(lastPt))
        }
    }
    return uniqueCoords.toTypedArray()
}

//fun clean(poly: Polygon?): Polygon? {
//    if(poly != null) {
//        return clean(poly)
//    } else {
//        return null
//    }
//}

// Extension property to get holes of a Polygon
//private val Polygon.holes: List<Geometry>
//    get() = (0 until numInteriorRing).map { getInteriorRingN(it) }
 fun clean(poly: Polygon): Polygon {
    val fact = poly.factory

    val shellCoords: Array<Coordinate> = removeDuplicatePoints(poly.exteriorRing!!.coordinates)
    val shell: LinearRing = fact.createLinearRing(shellCoords)
    val holes: MutableList<LinearRing> = ArrayList()
    for (i in 0..<poly.getNumInteriorRing()) {
        val holeCoords: Array<Coordinate> = removeDuplicatePoints(poly.getInteriorRingN(i).coordinates)
        holes.add(fact.createLinearRing(holeCoords))
    }
    return fact.createPolygon(shell, GeometryFactory.toLinearRingArray(holes))
}

private fun clean(g: MultiPolygon): MultiPolygon {
    val fact = g.factory

    val polys: MutableList<Polygon> = ArrayList()
    for (i in 0..<g.numGeometries) {
        val poly = g.getGeometryN(i) as Polygon
        polys.add(clean(poly))
    }
    return fact.createMultiPolygon(GeometryFactory.toPolygonArray(polys))
}

fun clean(g: Geometry): Geometry {
    val fact = g.factory
    if (g.isEmpty) return g
    return if (g is Point) g
//    else if (g is MultiPoint) g
//    else if (g is LinearRing) clean(g)
//    else if (g is LineString) clean(g)
    else if (g is Polygon) clean(g)
//    else if (g is MultiLineString) clean(g)
    else if (g is MultiPolygon) clean(g)
//    else if (g is GeometryCollection) clean(g)
    else throw UnsupportedOperationException(g::class.simpleName)
}